import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Config } from '../config';
import { ExceptionService } from '../core/exception.service';
import { Jurisdiction } from '../models/utility/utility-jurisdiction.model';

const apiEndpoints = Config.app?.apiEndpoints?.utilities;

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService
  ) {
    this.apiUrl = Config.projectApiUrl;
  }

  getCountriesAndStates(): Observable<{
    countries: Jurisdiction[];
    states: Jurisdiction[];
  }> {
    const url = `${this.apiUrl}${apiEndpoints.jurisdictions}`;
    return <
      Observable<{
        countries: Jurisdiction[];
        states: Jurisdiction[];
      }>
      >this.http.get(url).pipe(
        map(res => this.extractData<Jurisdiction[]>(res)),
        map(items => {
          const states = [];
          const countries = [];
          items.forEach(item => {
            if (item.jurisdictionTypeId === 1) {
              states.push(item);
            } else if (item.jurisdictionTypeId === 2) {
              countries.push(item);
            }
          });
          return {
            countries,
            states
          };
        }),
        catchError(res => this.exceptionService.catchBadResponse(res))
      );
  }

  getUserImageUrl(userId: string): string {
    const url = `${this.apiUrl}${apiEndpoints.userImage}/${userId}`;
    return url;
  }

  private extractData<T>(res: any) {
    if (res && (res.status < 200 || res.status >= 300)) {
      throw new Error('Bad response status: ' + res.status);
    }
    return <T>(res || {});
  }

  /**
   * Will get the duplicate items from an array
   * @param {any[]} array
   * @return {*}  {any[]}
   * @memberof UtilityService
   */
  getDuplicates(array: any[] = [], ignoreList: any[] = []): any[] {
    const duplicateEntries = new Set();
    const visited = new Set();
    const ignoreSet = new Set(ignoreList);
      for (const item of array) {
        if (visited.has(item) && !ignoreSet.has(item)) {
          duplicateEntries.add(item);
        } else {
          visited.add(item);
        }
      }
    return [...duplicateEntries];
  }
}
